import styled from "styled-components";


export const Container = styled.main`
  position: relative;
  z-index: 0;
  padding: 0 10rem;
  overflow-x: hidden;
  /* clip does not turn <main> into a scroll container, which would break position: sticky inside it */
  overflow-x: clip;
  #tsparticles{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  /* Content paints above the fixed particles canvas (z-index 0 inside this stacking context) */
  & > section{
    position: relative;
    z-index: 1;
  }

  @media (max-width: 740px){
    padding: 0 4rem;
  }

  @media(max-width: 360px){
    padding: 0 2rem;
  }
`